import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../http/HttpUtils';
import { RegistrationRequest } from './Requests/RegistrationRequest';

@Injectable({ providedIn: 'root' })
export class RegistrationApi
{
    async register(request: RegistrationRequest): Promise<void>
    {
        if (!request.AcceptTerms)
        {
            throw new Error('Terms must be accepted');
        }

        const res = await fetch('/api/account/register', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(request)
        });

        await HttpUtils.ProcessFetchResultAsync(res);
    }
}
